import styled from 'styled-components';

export const ContainerStudies = styled.div`
  padding: var(--spacing-3xl) var(--spacing-xl);
  min-height: calc(100vh - 200px);
  background-color: var(--bg-main);
  margin: 0;

  .page-header {
    margin-bottom: var(--spacing-3xl);
    
    h2 {
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      margin-bottom: var(--spacing-sm);
      font-size: var(--font-size-2xl);
    }
    
    p {
      font-size: var(--font-size-lg);
      margin-bottom: 0;
      color: var(--text-secondary);
    }
  }

  .filter-section {
    background: var(--bg-light);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-2xl);
    margin-bottom: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
    border: none;
  }

  .table-section {
    background: var(--bg-light);
    border-radius: var(--border-radius-lg);
    padding: var(--spacing-2xl);
    box-shadow: var(--shadow-md);
    border: none;
    overflow: visible;
    position: relative;
  }

  table {
    margin-bottom: 60px; /* Adicionar espaço para o dropdown */
    font-size: var(--font-size-sm) !important;
    overflow: visible;

    th {
      background-color: var(--gray-100);
      border-top: none;
      color: var(--primary-color);
      font-weight: var(--font-weight-semibold);
      padding: var(--spacing-lg);
    }

    td {
      padding: var(--spacing-lg);
      vertical-align: middle;
      color: var(--text-muted);
      border-color: var(--gray-200);
    }

    tbody tr:hover {
      background-color: var(--gray-100);
    }

    /* Garantir que o dropdown não seja cortado */
    tbody {
      overflow: visible;
    }

    /* Espaço extra para últimas linhas */
    tbody tr:nth-last-child(-n+3) .action-menu-container {
      margin-bottom: var(--spacing-xl);
    }
  }

  .filter {
    display: flex;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-lg);
  }

  th:nth-of-type(2) {
    width: 20vw;
  }
  th:nth-of-type(3) {
    width: 15vw;
  }
  th:nth-of-type(4) {
    width: 10vw;
  }
  th:nth-of-type(5) {
    width: 15vw;
  }
  th:nth-of-type(6) {
    width: 15vw;
  }
  th:nth-of-type(7) {
    width: 80px;
  }

  /* Estilos específicos para o menu de ações moderno */
  .action-menu-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 10;
    text-align: center !important;
    vertical-align: middle !important;
  }

  /* Melhorar responsividade da tabela */
  .table-responsive {
    border-radius: var(--border-radius-md);
    overflow-x: auto;
    overflow-y: visible;
    padding-bottom: var(--spacing-xl); /* Espaço extra para dropdown */
  }

  /* Ajustar padding das células para o novo menu */
  table td:last-child {
    padding: var(--spacing-sm);
    position: relative;
  }

  /* Garantir que o menu dropdown não seja cortado */
  table tbody tr {
    position: relative;
  }

  table tbody tr:last-child .action-menu-container {
    /* Para a última linha, abrir o menu para cima */
    position: static;
  }

  /* Estilos para paginação */
  .pagination-section {
    border-top: 1px solid var(--gray-200);
    padding-top: var(--spacing-xl);
    margin-top: var(--spacing-2xl); /* Aumentar margem superior */
  }

  .pagination-info {
    color: var(--text-secondary);
    font-size: var(--font-size-sm);
  }

  .pagination-controls {
    gap: var(--spacing-sm);
    
    button {
      min-width: 80px;
      font-size: var(--font-size-sm);
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
    }
    
    span {
      font-weight: var(--font-weight-medium);
      color: var(--primary-color);
      white-space: nowrap;
    }
  }
  
  @media (max-width: 1180px) {
    width: 100%;
    float: none !important;
    margin-left: 0px !important;
    padding: var(--spacing-md);
  }
`;

export const ContainerLoading = styled.div`
  height: calc(100vh - 7.5rem);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-light);

  h1 {
    font-size: var(--font-size-xl);
    font-weight: var(--font-weight-bold);
    color: var(--primary-color);
    text-align: center;
    margin-top: var(--spacing-lg);
  }
`;
